// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Payment Page Styles */
.payment-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
}

.payment-container {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 3rem;
    max-width: 1000px;
    width: 100%;
}

/* Payment Form Section */
.payment-form-section {
    background: #ffffff;
    border-radius: 1rem;
    padding: 2.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.back-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: none;
    border: none;
    color: #64748b;
    font-size: 0.875rem;
    cursor: pointer;
    padding: 0;
    margin-bottom: 1.5rem;
    transition: color 0.2s;
}

.back-button:hover {
    color: #4f46e5;
}

.back-button svg {
    width: 1rem;
    height: 1rem;
}

.payment-form-section h1 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
}

.form-subtitle {
    color: #64748b;
    margin-bottom: 2rem;
}


/* Form Styles */
.payment-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
}

.form-group input,
.form-group select {
    padding: 0.875rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    font-size: 1rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
}

.form-group input:focus,
.form-group select:focus {
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.form-group input.error {
    border-color: #ef4444;
}

.error-text {
    font-size: 0.75rem;
    color: #ef4444;
}

/* Card Input */
.card-input-wrapper {
    position: relative;
}

.card-number-input {
    width: 100%;
    padding-right: 5rem !important;
}

.card-icons {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    gap: 0.25rem;
}

.card-icon {
    width: 2rem;
    height: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #cbd5e1;
    transition: color 0.2s;
}

.card-icon.active {
    color: #4f46e5;
}

.card-details-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
    margin-top: 0;
}

.card-details-row input:first-child {
    border-radius: 0 0 0 0.5rem;
    border-top: none;
    border-right: none;
}

.card-details-row input:last-child {
    border-radius: 0 0 0.5rem 0;
    border-top: none;
}

.card-number-input {
    border-radius: 0.5rem 0.5rem 0 0 !important;
}

.country-select {
    border-radius: 0.5rem 0.5rem 0 0;
}

.zip-input {
    border-top: none !important;
    border-radius: 0 0 0.5rem 0.5rem !important;
}

/* Pay Button */
.pay-button {
    width: 100%;
    padding: 1rem;
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    color: white;
    border: none;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.pay-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
}

.pay-button:disabled {
    opacity: 0.8;
    cursor: not-allowed;
}

.pay-button.processing {
    background: #6366f1;
}

.spinner {
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.secure-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-size: 0.8125rem;
    color: #64748b;
    margin-top: 0.5rem;
}

.secure-text svg {
    width: 1rem;
    height: 1rem;
}

/* Recurring subscription disclosure — shown before the pay button (compliance + trust). */
.recurring-notice {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    padding: 0.75rem 0.9rem;
    margin-bottom: 1rem;
    background: #eef0fd;
    border: 1px solid #d7dbf7;
    border-radius: 10px;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: #3a3f66;
}

.recurring-notice svg {
    width: 1.05rem;
    height: 1.05rem;
    flex-shrink: 0;
    margin-top: 1px;
    color: #4346ce;
}

.recurring-notice strong {
    color: #1f2340;
}


/* Order Summary Section */
.order-summary-section {
    position: sticky;
    top: 2rem;
}

.order-summary-card {
    background: #ffffff;
    border-radius: 1rem;
    padding: 2rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.order-summary-card h3 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1.5rem;
}

.plan-info {
    margin-bottom: 1.5rem;
}

.plan-badge {
    display: inline-block;
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    color: white;
    font-size: 0.875rem;
    font-weight: 600;
    padding: 0.5rem 1rem;
    border-radius: 2rem;
    margin-bottom: 0.5rem;
}

.plan-billing {
    font-size: 0.875rem;
    color: #64748b;
}

.summary-divider {
    height: 1px;
    background: #e2e8f0;
    margin: 1rem 0;
}

.summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    font-size: 0.9375rem;
    color: #475569;
}

.summary-row.discount {
    color: #10b981;
}

.discount-amount {
    font-weight: 600;
}

.summary-row.total {
    font-size: 1.125rem;
    font-weight: 700;
    color: #1e293b;
    padding: 1rem 0;
}

.summary-features {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e2e8f0;
}

.summary-features h4 {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 1rem;
}

.summary-features ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.summary-features li {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 0.875rem;
    color: #475569;
    margin-bottom: 0.75rem;
}

.summary-features li svg {
    width: 1rem;
    height: 1rem;
    color: #10b981;
    flex-shrink: 0;
}

.guarantee-box {
    display: flex;
    gap: 1rem;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 0.75rem;
    padding: 1rem;
    margin-top: 1.5rem;
}

.guarantee-box svg {
    width: 1.5rem;
    height: 1.5rem;
    color: #10b981;
    flex-shrink: 0;
}

.guarantee-box strong {
    display: block;
    font-size: 0.875rem;
    color: #166534;
    margin-bottom: 0.25rem;
}

.guarantee-box p {
    font-size: 0.75rem;
    color: #15803d;
    margin: 0;
}

/* Success Animation */
.payment-success-container {
    text-align: center;
    background: #ffffff;
    border-radius: 1rem;
    padding: 4rem 3rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    max-width: 400px;
}

.success-animation {
    margin-bottom: 2rem;
}

.checkmark {
    width: 80px;
    height: 80px;
}

.checkmark-circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #10b981;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark-check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    stroke: #10b981;
    stroke-width: 3;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

.payment-success-container h2 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
}

.payment-success-container p {
    color: #64748b;
    margin-bottom: 0.5rem;
}

.redirect-text {
    font-size: 0.875rem;
    color: #94a3b8;
}

/* Responsive */
@media (max-width: 900px) {
    .payment-container {
        grid-template-columns: 1fr;
    }

    .order-summary-section {
        position: static;
        order: -1;
    }
}

@media (max-width: 480px) {
    .payment-page {
        padding: 1rem;
    }

    .payment-form-section,
    .order-summary-card {
        padding: 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/billing/payment.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,8FAA8F;IAC9F,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,iBAAiB;IACjB,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;;AAGA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA,eAAe;AACf;IACI,WAAW;IACX,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,0FAA0F;AAC1F;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,8DAA8D;AAClE;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,mEAAmE;AACvE;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":["/* Payment Page Styles */\n.payment-page {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n}\n\n.payment-container {\n    display: grid;\n    grid-template-columns: 1fr 400px;\n    gap: 3rem;\n    max-width: 1000px;\n    width: 100%;\n}\n\n/* Payment Form Section */\n.payment-form-section {\n    background: #ffffff;\n    border-radius: 1rem;\n    padding: 2.5rem;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.back-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: none;\n    border: none;\n    color: #64748b;\n    font-size: 0.875rem;\n    cursor: pointer;\n    padding: 0;\n    margin-bottom: 1.5rem;\n    transition: color 0.2s;\n}\n\n.back-button:hover {\n    color: #4f46e5;\n}\n\n.back-button svg {\n    width: 1rem;\n    height: 1rem;\n}\n\n.payment-form-section h1 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n}\n\n.form-subtitle {\n    color: #64748b;\n    margin-bottom: 2rem;\n}\n\n\n/* Form Styles */\n.payment-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.form-group label {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #374151;\n}\n\n.form-group input,\n.form-group select {\n    padding: 0.875rem 1rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.5rem;\n    font-size: 1rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.form-group input.error {\n    border-color: #ef4444;\n}\n\n.error-text {\n    font-size: 0.75rem;\n    color: #ef4444;\n}\n\n/* Card Input */\n.card-input-wrapper {\n    position: relative;\n}\n\n.card-number-input {\n    width: 100%;\n    padding-right: 5rem !important;\n}\n\n.card-icons {\n    position: absolute;\n    right: 1rem;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    gap: 0.25rem;\n}\n\n.card-icon {\n    width: 2rem;\n    height: 1.25rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #cbd5e1;\n    transition: color 0.2s;\n}\n\n.card-icon.active {\n    color: #4f46e5;\n}\n\n.card-details-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0;\n    margin-top: 0;\n}\n\n.card-details-row input:first-child {\n    border-radius: 0 0 0 0.5rem;\n    border-top: none;\n    border-right: none;\n}\n\n.card-details-row input:last-child {\n    border-radius: 0 0 0.5rem 0;\n    border-top: none;\n}\n\n.card-number-input {\n    border-radius: 0.5rem 0.5rem 0 0 !important;\n}\n\n.country-select {\n    border-radius: 0.5rem 0.5rem 0 0;\n}\n\n.zip-input {\n    border-top: none !important;\n    border-radius: 0 0 0.5rem 0.5rem !important;\n}\n\n/* Pay Button */\n.pay-button {\n    width: 100%;\n    padding: 1rem;\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    color: white;\n    border: none;\n    border-radius: 0.5rem;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.pay-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n}\n\n.pay-button:disabled {\n    opacity: 0.8;\n    cursor: not-allowed;\n}\n\n.pay-button.processing {\n    background: #6366f1;\n}\n\n.spinner {\n    width: 1.25rem;\n    height: 1.25rem;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.secure-text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    font-size: 0.8125rem;\n    color: #64748b;\n    margin-top: 0.5rem;\n}\n\n.secure-text svg {\n    width: 1rem;\n    height: 1rem;\n}\n\n/* Recurring subscription disclosure — shown before the pay button (compliance + trust). */\n.recurring-notice {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.6rem;\n    padding: 0.75rem 0.9rem;\n    margin-bottom: 1rem;\n    background: #eef0fd;\n    border: 1px solid #d7dbf7;\n    border-radius: 10px;\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: #3a3f66;\n}\n\n.recurring-notice svg {\n    width: 1.05rem;\n    height: 1.05rem;\n    flex-shrink: 0;\n    margin-top: 1px;\n    color: #4346ce;\n}\n\n.recurring-notice strong {\n    color: #1f2340;\n}\n\n\n/* Order Summary Section */\n.order-summary-section {\n    position: sticky;\n    top: 2rem;\n}\n\n.order-summary-card {\n    background: #ffffff;\n    border-radius: 1rem;\n    padding: 2rem;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.order-summary-card h3 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 1.5rem;\n}\n\n.plan-info {\n    margin-bottom: 1.5rem;\n}\n\n.plan-badge {\n    display: inline-block;\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    color: white;\n    font-size: 0.875rem;\n    font-weight: 600;\n    padding: 0.5rem 1rem;\n    border-radius: 2rem;\n    margin-bottom: 0.5rem;\n}\n\n.plan-billing {\n    font-size: 0.875rem;\n    color: #64748b;\n}\n\n.summary-divider {\n    height: 1px;\n    background: #e2e8f0;\n    margin: 1rem 0;\n}\n\n.summary-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem 0;\n    font-size: 0.9375rem;\n    color: #475569;\n}\n\n.summary-row.discount {\n    color: #10b981;\n}\n\n.discount-amount {\n    font-weight: 600;\n}\n\n.summary-row.total {\n    font-size: 1.125rem;\n    font-weight: 700;\n    color: #1e293b;\n    padding: 1rem 0;\n}\n\n.summary-features {\n    margin-top: 1.5rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #e2e8f0;\n}\n\n.summary-features h4 {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 1rem;\n}\n\n.summary-features ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.summary-features li {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    font-size: 0.875rem;\n    color: #475569;\n    margin-bottom: 0.75rem;\n}\n\n.summary-features li svg {\n    width: 1rem;\n    height: 1rem;\n    color: #10b981;\n    flex-shrink: 0;\n}\n\n.guarantee-box {\n    display: flex;\n    gap: 1rem;\n    background: #f0fdf4;\n    border: 1px solid #bbf7d0;\n    border-radius: 0.75rem;\n    padding: 1rem;\n    margin-top: 1.5rem;\n}\n\n.guarantee-box svg {\n    width: 1.5rem;\n    height: 1.5rem;\n    color: #10b981;\n    flex-shrink: 0;\n}\n\n.guarantee-box strong {\n    display: block;\n    font-size: 0.875rem;\n    color: #166534;\n    margin-bottom: 0.25rem;\n}\n\n.guarantee-box p {\n    font-size: 0.75rem;\n    color: #15803d;\n    margin: 0;\n}\n\n/* Success Animation */\n.payment-success-container {\n    text-align: center;\n    background: #ffffff;\n    border-radius: 1rem;\n    padding: 4rem 3rem;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    max-width: 400px;\n}\n\n.success-animation {\n    margin-bottom: 2rem;\n}\n\n.checkmark {\n    width: 80px;\n    height: 80px;\n}\n\n.checkmark-circle {\n    stroke-dasharray: 166;\n    stroke-dashoffset: 166;\n    stroke-width: 2;\n    stroke-miterlimit: 10;\n    stroke: #10b981;\n    fill: none;\n    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;\n}\n\n.checkmark-check {\n    transform-origin: 50% 50%;\n    stroke-dasharray: 48;\n    stroke-dashoffset: 48;\n    stroke: #10b981;\n    stroke-width: 3;\n    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;\n}\n\n@keyframes stroke {\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n.payment-success-container h2 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n}\n\n.payment-success-container p {\n    color: #64748b;\n    margin-bottom: 0.5rem;\n}\n\n.redirect-text {\n    font-size: 0.875rem;\n    color: #94a3b8;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n    .payment-container {\n        grid-template-columns: 1fr;\n    }\n\n    .order-summary-section {\n        position: static;\n        order: -1;\n    }\n}\n\n@media (max-width: 480px) {\n    .payment-page {\n        padding: 1rem;\n    }\n\n    .payment-form-section,\n    .order-summary-card {\n        padding: 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
